import { QueryParams } from 'app/interfaces/network';
import { getUrl } from '../url';
import { headerContentTypeConfig, redirectUriConfig, xApiKeyConfig } from './config';
import { debugInfo } from '../debug';
/**
 * handelGetUrl
 * @param domain
 * @param endpoint
 * @param query
 * @param addRedirectApi
 * @returns string
 */
export const handelGetUrl = (
    domain: string,
    endpoint: string,
    query?: QueryParams,
    addRedirectApi?: boolean
): string => {
    let url = getUrl(domain, endpoint, query);

    if (addRedirectApi) {
        return `${url}&redirect_uri=${redirectUriConfig}`;
    }

    return url;
};
/**
 * getUrlCodeApi
 * @param url
 */
export const getUrlCodeApi = async(url: string)=>{
    try {
        const res = await fetch(url, { method: 'GET' });

        if (!res.ok){
            throw new Error(`Failed to fetch URL: ${url}`);
        }

        const resUrl = new URL(res.url);
        return resUrl.searchParams.get('code');
    } catch (error) {
        debugInfo('Error fetching URL:', error);
        throw error;
    }
};
/**
 * getTokenApi
 * @param url
 */
export const getTokenApi = async (url:string)=>{
    try {
        const res = await fetch(url, { method: 'POST' });

        if (!res.ok){
            throw new Error(`Failed to fetch URL: ${url}`);
        }

        return await res.json();
    } catch (error) {
        debugInfo('Error fetching URL:', error);
        throw error;
    }
};
/**
 * getUserDataApi
 * @param url
 * @param tokenType
 * @param accessToken
 */
export const getUserDataApi = async (url: string, tokenType: string, accessToken: string)=>{
    try {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': headerContentTypeConfig,
                Authorization: `${tokenType} ${accessToken}`,
                'x-api-key': xApiKeyConfig,
            },
        };

        const res = await fetch(url, options);

        if (!res.ok){
            throw new Error(`Failed to fetch URL: ${url}`);
        }

        return await res.json();
    } catch (error) {
        debugInfo('Error fetching URL:', error);
        throw error;
    }
};
